import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import SendIcon from '@mui/icons-material/Send';
import { LoadingButton } from '@mui/lab';
import { Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import Card from '@mui/material/Card';
import Hidden from '@mui/material/Hidden';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import { styled, useTheme } from '@mui/material/styles';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import HttpServices from 'src/services/httpService';
import { integrateModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import FacebookPage_icon from '../../assets/facebook.svg';
import Bluesky from '../../assets/bluesky.svg';
import GBusiness from '../../assets/google-my-business-logo.svg';
import Instagram from '../../assets/instagram.svg';
import LinkedIn_Icon from '../../assets/linked_in.svg';
import Pinterest_Icon from '../../assets/pinterest-icon.svg';
import Threads_Icon from '../../assets/threads.png';
import TikTok_Icon from '../../assets/tiktok.svg';
import Twitter from '../../assets/twitter.svg';
import SnapChat_Icon from '../../assets/snapchat.svg';
import YouTube_Icon from '../../assets/youtube.png';
import FacebookGroupIntegration from './facebookIntegration/facebookGroupIntegration.component';
import FacebookPageIntegration from './facebookIntegration/facebookIntegration.component';
import GoogleMyBusinessIntegration from './google-my-business-integration/google-my-business-integration.component';
import InstagramCommonIntegration from './instagramIntegration/instagramcommonIntegration';
import LinkedInPageIntegration from './linkedinIntegration/linkedinPageIntegration.component';
import LinkedInProfileIntegration from './linkedinIntegration/linkedinProfileIntegration.component';
import PinterestIntegration from './pinterestIntegration/pinteresIntegration.component';
import ThreadsIntegration from './threads-integration/threads-integration.component';
import TiktokIntegration from './tiktokIntegration/tiktokIntegration.component';
import TwitterAppSumoIntegration from './twitterAppsumoUser-integration/twitterAppSumoIntegration.component';
import TwitterIntegration from './twitterIntegration/twitterIntegration.component';
import YouTubeIntegration from './youtubeIntegration/youtubeIntegration.component';
import BlueskyIntegration from './blueskyIntegration/blueskyAppSumoIntegration.component';
import SnapchatIntegration from './snapchatIntegration/SnapchatIntegration.component';
import { useTranslation } from 'react-i18next';

const NewIntegrationComponent = ({handleConnect}) => {
  const { t: translate } = useTranslation();
  const isAppSumoUser = CommonHelper.GetBrandInfoFromLocalStorage('is_appsumo_user');

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { showToast } = useToaster();

  //State Variables
  const [facebookPageIntegrationOpen, setfacebookPageIntegrationOpen] = useState(false);
  const [facebookGroupIntegrationOpen, setfacebookGroupIntegrationOpen] = useState(false);
  const [instagramCommonIntegrationOpen, setInstagramCommonIntegrationOpen] = useState(false);
  const [twitterIntegrationOpen, setTwitterIntegrationOpen] = useState(false);
  const [twitterDeveloperIntegrationOpen, setTwitterDeveloperIntegrationOpen] = useState(false);
  const [youtubeIntegrationOpen, setYoutubeIntegrationOpen] = useState(false);
  const [googleMyBusinessIntegrationOpen, setGoogleMyBusinessIntegrationOpen] = useState(false);
  const [threadsIntegrationOpen, setThreadsIntegrationOpen] = useState(false);
  const [linkedInProfileIntegrationOpen, setLinkedInProfileIntegrationOpen] = useState(false);
  const [linkedInPageIntegrationOpen, setLinkedInPageIntegrationOpen] = useState(false);
  const [tiktokIntegrationOpen, setTiktokIntegrationOpen] = useState(false);
  const [pinterestIntegrationOpen, setPinterestIntegrationOpen] = useState(false);
  const [blueskyIntegrationOpen, setBlueskyIntegrationOpen] = useState(false);
const [snapChatIntegrationOpen, setSnapChatIntegrationOpen] = useState(false);
  const responseHeight = isMobile ? 'calc(100vh - 230px)' : 'calc(100vh - 210px)';
  const isIntegSocial = CommonHelper.IsIntegSocialDomain();

  const handleSnapChat = (show = false) => {
    setSnapChatIntegrationOpen(show);
    typeof handleConnect === 'function' && show === false && handleConnect();
  };

  const handleTiktok = (show = false) => {
    setTiktokIntegrationOpen(show);
     typeof handleConnect === 'function' && show === false && handleConnect()
  };

  const handlePinterest = (show = false) => {
    setPinterestIntegrationOpen(show);
     typeof handleConnect === 'function' && show === false && handleConnect()
  };
  const handleYoutube = (show = false) => {
    setYoutubeIntegrationOpen(show);
     typeof handleConnect === 'function' && show === false && handleConnect()
  };
  const handleGoogleMyBusiness = (show = false) => {
    setGoogleMyBusinessIntegrationOpen(show);
     typeof handleConnect === 'function' && show === false && handleConnect()
  };
  const handleThreads = (show = false) => {
    setThreadsIntegrationOpen(show);
     typeof handleConnect === 'function' && show === false && handleConnect()
  };
  const handleFacebookPage = (show = false) => {
    setfacebookPageIntegrationOpen(show);
     typeof handleConnect === 'function' && show === false && handleConnect()
  };
  const handleFacebookGroup = (show = false) => {
    setfacebookGroupIntegrationOpen(show);
     typeof handleConnect === 'function' && show === false && handleConnect()
  };
  const handleCommonInstagram = (show = false) => {
    setInstagramCommonIntegrationOpen(show);
     typeof handleConnect === 'function' && show === false && handleConnect()
  };
  const handleTwitter = (show = false) => {
    setTwitterIntegrationOpen(show);
     typeof handleConnect === 'function' && show === false && handleConnect()
  };
  const handleDeveloperTwitter = (show = false) => {
    setTwitterDeveloperIntegrationOpen(show);
    typeof handleConnect === 'function' && show === false && handleConnect()
  };
  const handleBluesky = (show = false) => {
    setBlueskyIntegrationOpen(show);
    typeof handleConnect === 'function' && show === false && handleConnect()
  };
  const handleLinkedInProfile = (show = false) => {
    setLinkedInProfileIntegrationOpen(show);
     typeof handleConnect === 'function' && show === false && handleConnect()
  };
  const handleLinkedInPage = (show = false) => {
    setLinkedInPageIntegrationOpen(show);
     typeof handleConnect === 'function' && show === false && handleConnect()
  };
  const contactUsSuccessCallback = (data, message) => {
    showToast('Please wait until, we will get back to you', 's');
  };
  const failureCallback = (message) => {
    message && showToast(message, 'e');
  };
  const handleContactUs = () => {
    let getProps = {
      url: integrateModuleURL.handleContactUs,
      successCallback: contactUsSuccessCallback,
      failureCallback,
    };
    HttpServices.Get(getProps);
  };

  //Styled Components

  const listItemHoverStyles = {
    '&:hover': {
      backgroundColor: 'action.hover',
      borderRadius: 1,
    },
    transition: 'background-color 0.2s ease-in-out',
  };

  const Demo = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
  }));

  return (
    <>
      <Helmet>
        <title>{translate('navbar.menu.integration')}</title>
      </Helmet>
      <>
        <Typography variant="body2" sx={{ textAlign: 'center', mb: 2 }}>
          {translate('integration.iso_header')}
        </Typography>
        <Grid
          xs={12}
          md={6}
          sx={{
            borderRadius: 2,
            mt: isMobile ? 2 : 3,
            maxHeight: responseHeight,
            minHeight: responseHeight,
            overflowY: 'auto',
          }}
        >
          <Demo>
            {isIntegSocial ? (
              <Card>
                <List sx={listItemHoverStyles}>
                  <ListItem
                    secondaryAction={
                      <LoadingButton
                        variant="contained"
                        loading={facebookPageIntegrationOpen}
                        endIcon={<SendIcon />}
                        size="small"
                        onClick={() => {
                          handleFacebookPage(true);
                        }}
                      >
                        <Hidden only={['xs', 'sm']}>{translate('common.connect')}</Hidden>
                      </LoadingButton>
                    }
                  >
                    <ListItemAvatar>
                      <img sx={{ variant: 'rounded' }} width={30} height={30} src={FacebookPage_icon} />
                    </ListItemAvatar>
                    <ListItemText primary="Facebook Page" />
                  </ListItem>
                </List>
                <Divider />
                <List sx={listItemHoverStyles}>
                  <ListItem
                    secondaryAction={
                      <LoadingButton
                        variant="contained"
                        loading={instagramCommonIntegrationOpen}
                        endIcon={<SendIcon />}
                        size="small"
                        onClick={() => {
                          handleCommonInstagram(true);
                        }}
                      >
                        <Hidden only={['xs', 'sm']}>{translate('common.connect')}</Hidden>
                      </LoadingButton>
                    }
                  >
                    <ListItemAvatar>
                      <img sx={{ variant: 'rounded' }} width={25} height={30} src={Instagram} />
                    </ListItemAvatar>
                    <ListItemText primary="Instagram" />
                  </ListItem>
                </List>
                <Divider />

                <List sx={listItemHoverStyles}>
                  <ListItem
                    secondaryAction={
                      <LoadingButton
                        variant="contained"
                        loading={googleMyBusinessIntegrationOpen}
                        endIcon={<SendIcon />}
                        size="small"
                        onClick={() => {
                          handleGoogleMyBusiness(true);
                        }}
                      >
                        <Hidden only={['xs', 'sm']}>{translate('common.connect')}</Hidden>
                      </LoadingButton>
                    }
                  >
                    <ListItemAvatar>
                      <img sx={{ variant: 'rounded' }} width={30} height={30} src={GBusiness} />
                    </ListItemAvatar>
                    <ListItemText primary="Google My Business" />
                  </ListItem>
                </List>
              </Card>
            ) : (
              <Card>
                <List sx={listItemHoverStyles}>
                  <ListItem
                    secondaryAction={
                      <LoadingButton
                        variant="contained"
                        loading={facebookPageIntegrationOpen}
                        endIcon={<SendIcon />}
                        size="small"
                        onClick={() => {
                          handleFacebookPage(true);
                        }}
                      >
                        <Hidden only={['xs', 'sm']}>{translate('common.connect')}</Hidden>
                      </LoadingButton>
                    }
                  >
                    <ListItemAvatar>
                      <img sx={{ variant: 'rounded' }} width={30} height={30} src={FacebookPage_icon} />
                    </ListItemAvatar>
                    <ListItemText primary="Facebook Page" />
                  </ListItem>
                </List>
                <Divider />
                <List sx={listItemHoverStyles}>
                  <ListItem
                    secondaryAction={
                      <LoadingButton
                        variant="contained"
                        loading={instagramCommonIntegrationOpen}
                        endIcon={<SendIcon />}
                        size="small"
                        onClick={() => {
                          handleCommonInstagram(true);
                        }}
                      >
                        <Hidden only={['xs', 'sm']}>{translate('common.connect')}</Hidden>
                      </LoadingButton>
                    }
                  >
                    <ListItemAvatar>
                      <img sx={{ variant: 'rounded' }} width={25} height={30} src={Instagram} />
                    </ListItemAvatar>
                    <ListItemText primary="Instagram" />
                  </ListItem>
                </List>
                <Divider />
                {/* {isAppSumoUser ? (
                <List sx={listItemHoverStyles}>
                  <ListItem
                    secondaryAction={
                      <LoadingButton
                        variant="contained"
                        loading={twitterDeveloperIntegrationOpen}
                        size="small"
                        endIcon={<SendIcon />}
                        onClick={() => {
                          handleDeveloperTwitter(true);
                        }}
                      >
                        <Hidden only={['xs', 'sm']}>{translate('common.connect')}</Hidden>
                      </LoadingButton>
                    }
                  >
                    <ListItemAvatar>
                      <img sx={{ variant: 'rounded' }} width={25} height={25} src={Twitter} />
                    </ListItemAvatar>
                    <ListItemText primary="Twitter" />
                  </ListItem>
                </List>
              ) : (
                <List sx={listItemHoverStyles}>
                  <ListItem
                    secondaryAction={
                      <LoadingButton
                        variant="contained"
                        loading={twitterIntegrationOpen}
                        size="small"
                        endIcon={<SendIcon />}
                        onClick={() => {
                          handleTwitter(true);
                        }}
                      >
                        <Hidden only={['xs', 'sm']}>{translate('common.connect')}</Hidden>
                      </LoadingButton>
                    }
                  >
                    <ListItemAvatar>
                      <img sx={{ variant: 'rounded' }} width={25} height={25} src={Twitter} />
                    </ListItemAvatar>
                    <ListItemText primary="Twitter" />
                  </ListItem>
                </List>
              )} */}
                <List sx={listItemHoverStyles}>
                  <ListItem
                    secondaryAction={
                      <LoadingButton
                        variant="contained"
                        loading={twitterDeveloperIntegrationOpen}
                        size="small"
                        endIcon={<SendIcon />}
                        onClick={() => {
                          handleDeveloperTwitter(true);
                        }}
                      >
                        <Hidden only={['xs', 'sm']}>{translate('common.connect')}</Hidden>
                      </LoadingButton>
                    }
                  >
                    <ListItemAvatar>
                      <img sx={{ variant: 'rounded' }} width={25} height={25} src={Twitter} />
                    </ListItemAvatar>
                    <ListItemText primary="Twitter" />
                  </ListItem>
                </List>
                <Divider />
                <List sx={listItemHoverStyles}>
                  <ListItem
                    secondaryAction={
                      <LoadingButton
                        variant="contained"
                        loading={youtubeIntegrationOpen}
                        endIcon={<SendIcon />}
                        size="small"
                        onClick={() => {
                          handleYoutube(true);
                        }}
                      >
                        <Hidden only={['xs', 'sm']}>{translate('common.connect')}</Hidden>
                      </LoadingButton>
                    }
                  >
                    <ListItemAvatar>
                      <img sx={{ variant: 'rounded' }} width={35} height={35} src={YouTube_Icon} />
                    </ListItemAvatar>
                    <ListItemText primary="Youtube" />
                  </ListItem>
                </List>
                <Divider />
                <List sx={listItemHoverStyles}>
                  <ListItem
                    secondaryAction={
                      <LoadingButton
                        variant="contained"
                        loading={linkedInProfileIntegrationOpen}
                        endIcon={<SendIcon />}
                        size="small"
                        onClick={() => {
                          handleLinkedInProfile(true);
                        }}
                      >
                        <Hidden only={['xs', 'sm']}>{translate('common.connect')}</Hidden>
                      </LoadingButton>
                    }
                  >
                    <ListItemAvatar>
                      <img sx={{ variant: 'rounded' }} width={30} height={30} src={LinkedIn_Icon} />
                    </ListItemAvatar>
                    <ListItemText primary="LinkedIn Profile" />
                  </ListItem>
                </List>
                <Divider />
                <List sx={listItemHoverStyles}>
                  <ListItem
                    secondaryAction={
                      <LoadingButton
                        variant="contained"
                        loading={linkedInPageIntegrationOpen}
                        endIcon={<SendIcon />}
                        size="small"
                        onClick={() => {
                          handleLinkedInPage(true);
                        }}
                      >
                        <Hidden only={['xs', 'sm']}>{translate('common.connect')}</Hidden>
                      </LoadingButton>
                    }
                  >
                    <ListItemAvatar>
                      <img sx={{ variant: 'rounded' }} width={30} height={30} src={LinkedIn_Icon} />
                    </ListItemAvatar>
                    <ListItemText primary="LinkedIn Page" />
                  </ListItem>
                </List>
                <Divider />
                <List sx={listItemHoverStyles}>
                  <ListItem
                    secondaryAction={
                      <LoadingButton
                        variant="contained"
                        loading={pinterestIntegrationOpen}
                        endIcon={<SendIcon />}
                        size="small"
                        onClick={() => {
                          handlePinterest(true);
                        }}
                      >
                        <Hidden only={['xs', 'sm']}>{translate('common.connect')}</Hidden>
                      </LoadingButton>
                    }
                  >
                    <ListItemAvatar>
                      <img sx={{ variant: 'rounded' }} width={30} height={30} src={Pinterest_Icon} />
                    </ListItemAvatar>
                    <ListItemText primary="Pinterest" />
                  </ListItem>
                </List>
                <Divider />
                <List sx={listItemHoverStyles}>
                  <ListItem
                    secondaryAction={
                      <LoadingButton
                        variant="contained"
                        loading={googleMyBusinessIntegrationOpen}
                        endIcon={<SendIcon />}
                        size="small"
                        onClick={() => {
                          handleGoogleMyBusiness(true);
                        }}
                      >
                        <Hidden only={['xs', 'sm']}>{translate('common.connect')}</Hidden>
                      </LoadingButton>
                    }
                  >
                    <ListItemAvatar>
                      <img sx={{ variant: 'rounded' }} width={30} height={30} src={GBusiness} />
                    </ListItemAvatar>
                    <ListItemText primary="Google My Business" />
                  </ListItem>
                </List>
                <Divider />
                <List sx={listItemHoverStyles}>
                  <ListItem
                    secondaryAction={
                      <LoadingButton
                        variant="contained"
                        loading={tiktokIntegrationOpen}
                        endIcon={<SendIcon />}
                        size="small"
                        onClick={() => {
                          handleTiktok(true);
                        }}
                      >
                        <Hidden only={['xs', 'sm']}>{translate('common.connect')}</Hidden>
                      </LoadingButton>
                    }
                  >
                    <ListItemAvatar>
                      <img sx={{ variant: 'rounded' }} width={26} height={26} src={TikTok_Icon} />
                    </ListItemAvatar>
                    <ListItemText primary="TikTok" />
                  </ListItem>
                </List>
                <Divider />
                <List sx={listItemHoverStyles}>
                  <ListItem
                    secondaryAction={
                      <LoadingButton
                        variant="contained"
                        loading={threadsIntegrationOpen}
                        endIcon={<SendIcon />}
                        size="small"
                        onClick={() => {
                          handleThreads(true);
                        }}
                      >
                        <Hidden only={['xs', 'sm']}>{translate('common.connect')}</Hidden>
                      </LoadingButton>
                    }
                  >
                    <ListItemAvatar>
                      <img sx={{ variant: 'rounded' }} width={30} height={30} src={Threads_Icon} />
                    </ListItemAvatar>
                    <ListItemText primary="Threads" />
                  </ListItem>
                </List>
                <Divider />
                <List sx={listItemHoverStyles}>
                  <ListItem
                    secondaryAction={
                      <LoadingButton
                        variant="contained"
                        loading={blueskyIntegrationOpen}
                        endIcon={<SendIcon />}
                        size="small"
                        onClick={() => {
                          handleBluesky(true);
                        }}
                      >
                        <Hidden only={['xs', 'sm']}>{translate('common.connect')}</Hidden>
                      </LoadingButton>
                    }
                  >
                    <ListItemAvatar>
                      <img sx={{ variant: 'rounded' }} width={30} height={30} src={Bluesky} />
                    </ListItemAvatar>
                    <ListItemText primary="Bluesky" />
                  </ListItem>
                </List>
                <List sx={listItemHoverStyles}>
            <ListItem
              secondaryAction={
                <LoadingButton
                  variant="contained"
                  loading={snapChatIntegrationOpen}
                  endIcon={<SendIcon />}
                  size="small"
                  onClick={() => handleSnapChat(true)}
                >
                  <Hidden only={['xs', 'sm']}>{translate('common.connect')}</Hidden>
                </LoadingButton>
              }
            >
              <ListItemAvatar>
                <img width={30} height={30} src={SnapChat_Icon} alt="Snapchat" />
              </ListItemAvatar>
              <ListItemText primary="Snapchat" />
            </ListItem>
          </List>
              </Card>
            )}
          </Demo>
        </Grid>
        {facebookPageIntegrationOpen && <FacebookPageIntegration handleClose={handleFacebookPage} />}
        {facebookGroupIntegrationOpen && <FacebookGroupIntegration handleClose={handleFacebookGroup} />}
        {instagramCommonIntegrationOpen && <InstagramCommonIntegration handleClose={handleCommonInstagram} />}
        {twitterIntegrationOpen && <TwitterIntegration handleClose={handleTwitter} />}
        {youtubeIntegrationOpen && <YouTubeIntegration handleClose={handleYoutube} />}
        {linkedInProfileIntegrationOpen && <LinkedInProfileIntegration handleClose={handleLinkedInProfile} />}
        {linkedInPageIntegrationOpen && <LinkedInPageIntegration handleClose={handleLinkedInPage} />}
        {tiktokIntegrationOpen && <TiktokIntegration handleClose={handleTiktok} />}
        {googleMyBusinessIntegrationOpen && <GoogleMyBusinessIntegration handleClose={handleGoogleMyBusiness} />}
        {threadsIntegrationOpen && <ThreadsIntegration handleClose={handleThreads} />}
        {blueskyIntegrationOpen && <BlueskyIntegration handleClose={handleBluesky} />}
        {twitterDeveloperIntegrationOpen && <TwitterAppSumoIntegration handleClose={handleDeveloperTwitter} />}
        {pinterestIntegrationOpen && <PinterestIntegration handleClose={handlePinterest} />}
        {snapChatIntegrationOpen && <SnapchatIntegration handleClose={handleSnapChat} />}
      </>
    </>
  );
};

export default NewIntegrationComponent;
